function DocIcon({ size }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 25'
    >
      <g clipPath='url(#clip0_2662_7882)'>
        <path
          fill='#0263D1'
          d='M6.147.5h8.03l6.798 7.092v13.786a3.122 3.122 0 01-3.122 3.122H6.147a3.122 3.122 0 01-3.122-3.122V3.622A3.122 3.122 0 016.147.5z'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M14.168.5v7.034h6.807L14.168.5z'
          clipRule='evenodd'
          opacity='0.302'
        />
        <path
          fill='#fff'
          d='M5.924 17.625v-3.973h1.407c.282 0 .544.042.787.12.242.08.462.197.66.352.197.155.352.362.466.621.113.26.171.557.171.893 0 .337-.058.634-.171.893a1.576 1.576 0 01-.466.621 2.163 2.163 0 01-.66.353c-.243.078-.505.12-.787.12H5.924zm.993-.864h.295c.158 0 .307-.02.44-.055.136-.039.259-.1.375-.181a.787.787 0 00.272-.35c.068-.149.1-.33.1-.537a1.32 1.32 0 00-.1-.54.795.795 0 00-.272-.346 1.185 1.185 0 00-.375-.181 1.706 1.706 0 00-.44-.055h-.295v2.245zm4.908.91c-.598 0-1.093-.195-1.485-.58-.391-.385-.585-.87-.585-1.453 0-.582.194-1.067.585-1.452.392-.385.887-.58 1.485-.58.59 0 1.078.195 1.47.58.387.385.582.87.582 1.452 0 .583-.195 1.068-.583 1.453-.391.385-.88.58-1.469.58zm-.763-1.195c.197.22.45.33.757.33s.556-.11.754-.33c.197-.223.294-.501.294-.838 0-.336-.097-.614-.294-.838a.965.965 0 00-.754-.33c-.307 0-.56.11-.757.33a1.218 1.218 0 00-.298.838c0 .337.1.615.298.838zm5.176 1.194c-.579 0-1.06-.181-1.442-.537-.385-.36-.576-.857-.576-1.495 0-.634.194-1.132.582-1.491.392-.36.867-.54 1.436-.54.515 0 .936.126 1.269.381.33.253.52.59.57 1.01l-1.004.204a.898.898 0 00-.297-.531.812.812 0 00-.544-.2c-.285 0-.52.1-.712.303-.19.208-.288.492-.288.864s.097.657.285.86c.19.208.427.308.715.308a.825.825 0 00.53-.175.766.766 0 00.276-.465l1.025.233c-.094.4-.3.711-.624.935-.32.223-.722.336-1.2.336z'
        />
      </g>
      <defs>
        <clipPath id='clip0_2662_7882'>
          <path fill='#fff' d='M0 0H24V24H0z' transform='translate(0 .5)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DocIcon;
